var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlertToaster(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.794,
    height: 29.237,
    viewBox: "0 0 28.794 29.237",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "alert_toaster",
    transform: "translate(-2.258 -1.892)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10178",
    "data-name": "Path 10178",
    d: "M5,17.742A11.742,11.742,0,1,0,16.742,6,11.742,11.742,0,0,0,5,17.742",
    transform: "translate(-0.087 0.644)",
    fill: "none",
    stroke: "#f9bc34",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10179",
    "data-name": "Path 10179",
    d: "M8.863,4,4.25,7.355",
    transform: "translate(-0.596 -0.711)",
    fill: "none",
    stroke: "#f9bc34",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10180",
    "data-name": "Path 10180",
    d: "M17,4l4.613,3.355",
    transform: "translate(8.042 -0.711)",
    fill: "none",
    stroke: "#f9bc34",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10181",
    "data-name": "Path 10181",
    d: "M8,15.032H9.677l3.355,5.032L16.387,10l3.355,5.032h1.677",
    transform: "translate(1.945 3.354)",
    fill: "none",
    stroke: "#f9bc34",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertToaster);
export default __webpack_public_path__ + "static/media/alert_toaster.d54928d16882f72e7958325efbc2feb9.svg";
export { ForwardRef as ReactComponent };